import { setupContentSliders } from '@/components/contentSlider'
import { lazyImages } from '@/components/lazyImages'
import { manageMobileMenu } from '@/components/mobileMenu'
import { init as animate } from '@/components/animate'

animate()
manageMobileMenu()
setupContentSliders()
lazyImages()

